// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.api.web.external.portalanalytics.CustomerAnalyticsEnterpriseAnalyticsApiHandler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AdproductsPackageCompetitorsDto,
  AreaDto,
  AreaSuggestion,
  CustomerAnalyticsAreaDto,
  CustomerAnalyticsEnterpriseAnalyticsOverviewDto,
  CustomerAnalyticsInsightsCompMetricType,
  CustomerAnalyticsInsightsMarketMetricCompsDto,
  CustomerAnalyticsInsightsMarketPriceCompsDto,
  CustomerAnalyticsInsightsMarketPriceOverviewDto,
  CustomerAnalyticsInsightsRenterExpectationDto,
  CustomerAnalyticsListingFilterType,
  CustomerAnalyticsListingPerformanceDailyBreakdownDtoV2,
  CustomerAnalyticsListingPerformanceDtoV2,
  CustomerAnalyticsListingQualitiesDto,
  InsightsRentPriceSummaryRequestDto,
  ListingAlias,
  OverviewSummaryByPropertyTypeDtoV2,
  PlaceResultDto,
} from '../..';

interface GetAreaParams {
  id: number;
}
interface GetAreaV2Params {
  id: number;
}
interface GetInsightsOverviewSummaryParams {
  areaId: number;
  filterLocation: string;
  filterState: string;
  listingFilterType?: CustomerAnalyticsListingFilterType;
  type: string;
}
interface GetListingPerformanceDailyBreakdownV2Params {
  endDayYyyyMmDd: string;
  includeFreeStats?: boolean;
  includeMarketInsights: boolean;
  listingAlias: ListingAlias;
  startDayYyyyMmDd: string;
}
interface GetListingPerformanceV2Params {
  endDayYyyyMmDd: string;
  includeFreeStats?: boolean;
  includeMarketInsights: boolean;
  listingAlias?: ListingAlias;
  startDayYyyyMmDd: string;
}
interface GetListingQualitiesParams {
  areaId: number;
  filterLocation: string;
  filterState: string;
  listingFilterType?: CustomerAnalyticsListingFilterType;
  type: string;
}
interface GetMultiFamilyListingMetricCompsParams {
  endDateYyyyMmDd?: string;
  metricType: CustomerAnalyticsInsightsCompMetricType;
  startDateYyyyMmDd?: string;
  unitId: number;
}
interface GetMultiFamilyListingPriceCompsParams {
  areaId: string;
  endDateYyyyMmDd?: string;
  numBedrooms: number;
  startDateYyyyMmDd?: string;
  unitId: string;
}
interface GetMultiFamilyListingPriceCompsByRegionIdParams {
  endDateYyyyMmDd?: string;
  numBedrooms: number;
  startDateYyyyMmDd?: string;
  unitId: string;
  zillowRegionId: number;
}
interface GetPackageCompetitorsParams {
  listingAlias: ListingAlias;
}
interface GetRenterExpectationsParams {
  areaId: string;
}
interface GetYearlyOverviewParams {
  includeFreeStats?: boolean;
  listingFilterType?: CustomerAnalyticsListingFilterType;
  listingId?: string;
  rocketshipFilter?: string;
}
interface SearchAreaParams {
  searchString: string;
}

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getArea_Path =
  '/api/web/v1/users/enterpriseAnalytics/getArea';

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getArea = (
  getParams: GetAreaParams,
  client = getClient(),
) => {
  return httpApiRequest<GetAreaParams, never, AreaDto>(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsEnterpriseAnalyticsApiHandler_getArea_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getAreaV2_Path =
  '/api/web/v1/users/enterpriseAnalytics/getAreaV2';

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getAreaV2 = (
  getParams: GetAreaV2Params,
  client = getClient(),
) => {
  return httpApiRequest<GetAreaV2Params, never, CustomerAnalyticsAreaDto>(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsEnterpriseAnalyticsApiHandler_getAreaV2_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getInsightsOverviewSummary_Path =
  '/api/web/v1/users/enterpriseAnalytics/getInsightsOverviewSummary';

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getInsightsOverviewSummary = (
  getParams: GetInsightsOverviewSummaryParams,
  client = getClient(),
) => {
  return httpApiRequest<GetInsightsOverviewSummaryParams, never, OverviewSummaryByPropertyTypeDtoV2>(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsEnterpriseAnalyticsApiHandler_getInsightsOverviewSummary_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getInsightsRentPriceSummary_Path =
  '/api/web/v1/users/enterpriseAnalytics/getInsightsRentPriceSummary';

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getInsightsRentPriceSummary = (
  postData: InsightsRentPriceSummaryRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, InsightsRentPriceSummaryRequestDto, CustomerAnalyticsInsightsMarketPriceOverviewDto>(
    {
      endpoint: CustomerAnalyticsEnterpriseAnalyticsApiHandler_getInsightsRentPriceSummary_Path,
      method: 'POST',
      contextPath: '/customer-analytics',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getListingPerformanceDailyBreakdownV2_Path =
  '/api/web/v1/users/enterpriseAnalytics/getListingPerformanceDailyBreakdownV2';

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getListingPerformanceDailyBreakdownV2 = (
  getParams: GetListingPerformanceDailyBreakdownV2Params,
  client = getClient(),
) => {
  return httpApiRequest<
    GetListingPerformanceDailyBreakdownV2Params,
    never,
    CustomerAnalyticsListingPerformanceDailyBreakdownDtoV2
  >(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsEnterpriseAnalyticsApiHandler_getListingPerformanceDailyBreakdownV2_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getListingPerformanceV2_Path =
  '/api/web/v1/users/enterpriseAnalytics/getListingPerformanceV2';

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getListingPerformanceV2 = (
  getParams: GetListingPerformanceV2Params,
  client = getClient(),
) => {
  return httpApiRequest<GetListingPerformanceV2Params, never, CustomerAnalyticsListingPerformanceDtoV2>(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsEnterpriseAnalyticsApiHandler_getListingPerformanceV2_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getListingQualities_Path =
  '/api/web/v1/users/enterpriseAnalytics/getListingQualities';

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getListingQualities = (
  getParams: GetListingQualitiesParams,
  client = getClient(),
) => {
  return httpApiRequest<GetListingQualitiesParams, never, CustomerAnalyticsListingQualitiesDto>(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsEnterpriseAnalyticsApiHandler_getListingQualities_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getMultiFamilyListingMetricComps_Path =
  '/api/web/v1/users/enterpriseAnalytics/getMultiFamilyListingMetricComps';

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getMultiFamilyListingMetricComps = (
  getParams: GetMultiFamilyListingMetricCompsParams,
  client = getClient(),
) => {
  return httpApiRequest<
    GetMultiFamilyListingMetricCompsParams,
    never,
    Array<CustomerAnalyticsInsightsMarketMetricCompsDto>
  >(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsEnterpriseAnalyticsApiHandler_getMultiFamilyListingMetricComps_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getMultiFamilyListingPriceComps_Path =
  '/api/web/v1/users/enterpriseAnalytics/getMultiFamilyListingPriceComps';

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getMultiFamilyListingPriceComps = (
  getParams: GetMultiFamilyListingPriceCompsParams,
  client = getClient(),
) => {
  return httpApiRequest<
    GetMultiFamilyListingPriceCompsParams,
    never,
    Array<CustomerAnalyticsInsightsMarketPriceCompsDto>
  >(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsEnterpriseAnalyticsApiHandler_getMultiFamilyListingPriceComps_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getMultiFamilyListingPriceCompsByRegionId_Path =
  '/api/web/v1/users/enterpriseAnalytics/getMultiFamilyListingPriceCompsByRegionId';

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getMultiFamilyListingPriceCompsByRegionId = (
  getParams: GetMultiFamilyListingPriceCompsByRegionIdParams,
  client = getClient(),
) => {
  return httpApiRequest<
    GetMultiFamilyListingPriceCompsByRegionIdParams,
    never,
    Array<CustomerAnalyticsInsightsMarketPriceCompsDto>
  >(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsEnterpriseAnalyticsApiHandler_getMultiFamilyListingPriceCompsByRegionId_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getPackageCompetitors_Path =
  '/api/web/v1/users/enterpriseAnalytics/getPackageCompetitors';

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getPackageCompetitors = (
  getParams: GetPackageCompetitorsParams,
  client = getClient(),
) => {
  return httpApiRequest<GetPackageCompetitorsParams, never, AdproductsPackageCompetitorsDto>(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsEnterpriseAnalyticsApiHandler_getPackageCompetitors_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getRenterExpectations_Path =
  '/api/web/v1/users/enterpriseAnalytics/getRenterExpectations';

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getRenterExpectations = (
  getParams: GetRenterExpectationsParams,
  client = getClient(),
) => {
  return httpApiRequest<GetRenterExpectationsParams, never, CustomerAnalyticsInsightsRenterExpectationDto>(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsEnterpriseAnalyticsApiHandler_getRenterExpectations_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getYearlyOverview_Path =
  '/api/web/v1/users/enterpriseAnalytics/getYearlyOverview';

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_getYearlyOverview = (
  getParams: GetYearlyOverviewParams,
  client = getClient(),
) => {
  return httpApiRequest<GetYearlyOverviewParams, never, CustomerAnalyticsEnterpriseAnalyticsOverviewDto>(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsEnterpriseAnalyticsApiHandler_getYearlyOverview_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_searchArea_Path =
  '/api/web/v1/users/enterpriseAnalytics/searchArea';

export const CustomerAnalyticsEnterpriseAnalyticsApiHandler_searchArea = (
  getParams: SearchAreaParams,
  client = getClient(),
) => {
  return httpApiRequest<SearchAreaParams, never, PlaceResultDto<Array<AreaSuggestion>>>(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsEnterpriseAnalyticsApiHandler_searchArea_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};
